import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { getPathVariables } from '../../../misc';
import {
  DueMonthlyWrapper,
  DueNowWrapper,
  LabelDueMonthly,
  BeforeTaxesLabel,
  PricingBlockMain,
  IntegralPart
} from '../css';

const Regular = ({ total }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { DUE_MONTHLY, DUE_NOW, BEFORE_TAXES }
  } = localizedStrings;

  const getFormattedPricing = price => {
    const locale = getPathVariables(window.location.pathname)[0];
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    const updatedprice = formatter.format(price);
    return <IntegralPart>{updatedprice}</IntegralPart>;
  };

  return (
    <>
      <DueMonthlyWrapper>
        <div>
          <LabelDueMonthly>{DUE_MONTHLY}</LabelDueMonthly>
          <PricingBlockMain>
            {getFormattedPricing(_.get(total, 'totalMonthly', 0))}
          </PricingBlockMain>
          <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
        </div>
      </DueMonthlyWrapper>
      <DueNowWrapper>
        <>
          <div>
            <LabelDueMonthly>{DUE_NOW}</LabelDueMonthly>
            <PricingBlockMain>
              {getFormattedPricing(_.get(total, 'totalOneTime', 0))}
            </PricingBlockMain>
            <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
          </div>
        </>
      </DueNowWrapper>
    </>
  );
};

Regular.propTypes = {
  total: PropTypes.objectOf(PropTypes.any).isRequired
};

export default Regular;
